import cn from 'classnames'
import * as React from 'react'

import styles from './AppTable.module.scss'

type TableHeaderType<DataItem> = {
  data: React.ReactNode
  key: keyof DataItem
  width?: number
  render?(value: any, full: DataItem): React.ReactNode
  hide?: boolean
}
interface AppTableProps<DataItem> {
  selected?: {
    value?: number | string
    key: keyof DataItem
  }
  headers?: TableHeaderType<DataItem>[]
  checkError?: (item: DataItem) => boolean
  onClickRow?(item: DataItem, index: number): void
  dataSource?: DataItem[]
  loading?: boolean
}

export function AppTable<DataItem>({
  headers = [],
  dataSource = [],
  selected,
  loading,
  onClickRow,
  checkError,
}: AppTableProps<DataItem>) {
  return (
    <div
      className={cn(styles.container, {
        [styles.loading]: loading,
      })}
    >
      <table className={styles.table}>
        <thead>
          <tr>
            {headers.map((item, index) => {
              if (item.hide) return null
              return (
                <td
                  style={{
                    minWidth: item.width,
                  }}
                  key={index}
                >
                  {item.data}
                </td>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {dataSource.map((item, index) => {
            return (
              <tr
                onClick={() => onClickRow?.(item, index)}
                className={cn({
                  [styles.active]: index % 2 === 0,
                  [styles.selected]:
                    selected && selected?.value === item[selected.key],
                  [styles.error]: checkError?.(item),
                })}
                key={index}
              >
                {headers.map(data => {
                  if (data.hide) return null
                  // FIXME: [object Object] key for objects
                  const key = `${index}_${String(data?.key)}`
                  const value = dataSource?.[index]?.[data?.key]

                  return (
                    <td
                      style={{
                        minWidth: data.width,
                      }}
                      key={Math.random()}
                    >
                      {data.render
                        ? data.render(value, dataSource?.[index])
                        : value}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
